import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faDownload, faEdit, faTrash} from '@fortawesome/free-solid-svg-icons';
import {getFileIcon} from '../utils/fileUtils';

/**
 * Individual file card component
 */
export const FileCard = ({file, showUpload, onDownload, onEdit, onDelete}) => {
  const ext = file.ext || '';
  const sizeKB = file.size ? Math.round(file.size / 1024) : 0;
  const {icon, color} = getFileIcon(ext);

  return (
    <div className="relative p-3 sm:p-3 rounded-lg border border-gray-200/70 dark:border-gray-600/70 hover:border-gray-300 dark:hover:border-gray-600 hover:shadow-sm transition-all bg-surface dark:bg-gray-870">
      {/* Mobile: Vertical layout */}
      <div className="sm:hidden space-y-2">
        <div className="flex items-start gap-2">
          <div className="flex-shrink-0 mt-0.5">
            <FontAwesomeIcon icon={icon} className={`w-5 h-5 ${color}`}/>
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-medium text-sm text-gray-900 dark:text-gray-100 break-words">
              {file.name}
            </div>
            <div className="flex items-center gap-2 mt-1">
              {ext && (
                <span className="px-1.5 py-0.5 text-xs font-medium rounded bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-200 uppercase">
                  {ext}
                </span>
              )}
              {file.uploaded && (
                <span className="text-xs text-gray-500 dark:text-gray-400">
                  {String(file.uploaded).slice(0, 10)}
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 pl-7">
          <button
            onClick={() => onDownload(file)}
            className="flex-1 py-1.5 px-3 text-xs font-medium rounded-md border border-brand-200 dark:border-brand-700 bg-brand-50 dark:bg-brand-900/30 text-brand-700 dark:text-brand-300 hover:bg-brand-100 dark:hover:bg-brand-900/50"
          >
            Download
          </button>
          {showUpload && (
            <>
              <button
                onClick={() => onEdit(file)}
                className="flex-1 py-1.5 px-3 text-xs font-medium rounded-md border border-blue-200 dark:border-blue-700 bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 hover:bg-blue-100 dark:hover:bg-blue-900/50"
              >
                Edit
              </button>
              <button
                onClick={() => onDelete(file)}
                className="flex-1 py-1.5 px-3 text-xs font-medium rounded-md border border-red-200 dark:border-red-700 bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-300 hover:bg-red-100 dark:hover:bg-red-900/50"
              >
                Delete
              </button>
            </>
          )}
        </div>
      </div>

      {/* Desktop: Horizontal layout */}
      <div className="hidden sm:flex items-start gap-4">
        <div className="flex-shrink-0 mt-1">
          <FontAwesomeIcon icon={icon} className={`w-6 h-6 ${color}`}/>
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1.5">
            <span className="font-medium text-sm text-gray-900 dark:text-gray-100 truncate">
              {file.name}
            </span>
            {ext && (
              <span className="px-1.5 py-0.5 text-xs font-medium rounded flex-shrink-0 bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-200 uppercase">
                {ext}
              </span>
            )}
          </div>

          <div className="text-xs text-gray-500 dark:text-gray-400 space-y-0.5">
            {sizeKB > 0 && (
              <div className="flex items-center gap-1.5">
                <span className="text-gray-400 dark:text-gray-500">Size:</span>
                <span>{sizeKB} KB</span>
              </div>
            )}
            {file.uploaded && (
              <div className="flex items-center gap-1.5">
                <span className="text-gray-400 dark:text-gray-500">Uploaded:</span>
                <span>{String(file.uploaded).slice(0, 10)}</span>
              </div>
            )}
          </div>
        </div>

        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={() => onDownload(file)}
            className="p-2 text-gray-600 dark:text-gray-400 hover:text-brand-600 dark:hover:text-brand-400 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-md transition-colors"
            title="Download"
          >
            <FontAwesomeIcon icon={faDownload} className="w-4 h-4"/>
          </button>

          {showUpload && (
            <>
              <button
                onClick={() => onEdit(file)}
                className="p-2 text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-md transition-colors"
                title="Edit"
              >
                <FontAwesomeIcon icon={faEdit} className="w-4 h-4"/>
              </button>
              <button
                onClick={() => onDelete(file)}
                className="p-2 text-gray-600 dark:text-gray-400 hover:text-red-600 dark:hover:text-red-400 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-md transition-colors"
                title="Delete"
              >
                <FontAwesomeIcon icon={faTrash} className="w-4 h-4"/>
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

